<template>
  <div id="app">
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card class="rounded-corner pa-2 elevation-3">
      <v-layout row wrap>
        <v-flex xs12 sm10 md10>
          <v-autocomplete
            append-icon="search"
            clearable
            :label="$t('Accound-Code')"
            :items="items"
            item-text="Text"
            item-value="CodeID"
            v-model="searchText"
            @blur="checkSearch()"
            @change="controlChange()"
            :search-input.sync="searchHesap"
            return-object
          >
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm12 md1 pt-3>
          <v-btn flat icon color="info" @click="openAddAccountDialog()">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 sm12 md1 pt-3>
          <v-btn flat icon color="info" @click="openSearchDialog()">
            <v-icon>search</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 sm12 md12 class="font-weight-large grey--text title" pb-2>
          <span v-if="searchText != null" style="color: #67768f">
            {{ searchText.CodeName }}
          </span></v-flex
        >

        <v-flex
          xs12
          sm12
          md5
          justify-start
          class="font-weight-large grey--text subheader"
          v-if="searchText != null"
          ><span style="color: #67768f"> {{ $t("Debit") }} :</span>
          {{ searchText.TotalDept | moneyformat }}
        </v-flex>
        <v-flex
          xs12
          sm12
          md5
          justify-center
          class="font-weight-large grey--text subheader"
          v-if="searchText != null"
          ><span style="color: #67768f"> {{ $t("Credit") }} :</span>
          {{ searchText.TotalCredit | moneyformat }}
        </v-flex>
        <v-flex
          xs12
          sm12
          md2
          justify-end
          class="font-weight-large grey--text subheader"
          v-if="searchText != null"
          ><span style="color: #67768f"> {{ $t("Balance") }} :</span>
          {{ searchText.TotalBalance | moneyformat }}
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row justify-center>
      <v-dialog v-model="searchDialog" persistent>
        <v-card>
          <v-card-text>
            <hesapkoduara
              ref="hesapkoduAra"
              @closeSearchData="setHesapKodu($event)"
            ></hesapkoduara>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="searchDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent>
        <v-card>
          <v-card-title class="headline">
            {{ $t("Add-v2", { value: $t("Accound-Code") }) }}
          </v-card-title>
          <v-card-text>
            <muhasebeislem
              ref="muhasebeIslem"
              @closeAddDialog="closeAccountingAddDialog($event)"
            ></muhasebeislem>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="addAccoutingCode()">{{
              $t("save_button")
            }}</v-btn>
            <v-btn color="primary" flat @click.native="dialog = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import auth from "@/api/auth";
import muhasebeislem from "@/components/app/muhasebe/muhasebekodlari/islemcomp.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import hesapkoduara from "@/components/app/muhasebe/comp/hesapkoduara.vue";

export default {
 
  props: ["value"],
  computed: {
    searchText: {
      get: function () {
        
        if (this.value != null) {
        
          if(typeof this.value.CodeID != "undefined"){

          let newItem = {
            CodeID: this.value.CodeID,
            CompanyID: this.value.CompanyID,
            Code: this.value.Code,
            CodeName: this.value.CodeName,
            BalanceType: this.value.BalanceType,
            Text: this.value.Code + " - " + this.value.CodeName,
            TotalBalance: this.value.TotalBalance,
            TotalCredit: this.value.TotalCredit,
            TotalDept: this.value.TotalDept,
          };
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.items.push(newItem);
          }
 
        }

        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      dialog: false,
      text1: null,
      snackbar: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      items: [],
      searchHesap: null,
      controlSearch: false,
      searchDialog: false,
      selectedID2:0
    };
  },
  methods: {
   
    openSearchDialog() {
      this.searchDialog = true;
    },
    closeAccountingAddDialog(val) {
      this.setHesapKodu(val);
      this.dialog = false;
    },
    addAccoutingCode() {
      this.$refs.muhasebeIslem.addAccoutingCode(2);
    },
    openAddAccountDialog() {
      this.dialog = true;
    },
    checkSearch() {
      this.controlSearch = true;
    },
    loadHesapKodu(id) {
     
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params1 = {
        UserID: 0,
        SearchText: null,
        CompanyID: credentials.MuhasebeSirketNo,
        MainCodeID: 0,
        Code: null,
        CodeID: id,
        BalanceShow: true,
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeLoad",
          params1,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            //this.items = response.body;
            var newItem = {
              CodeID: response.body.CodeID,
              CompanyID: response.body.CompanyID,
              Code: response.body.Code,
              CodeName: response.body.CodeName,
              BalanceType: response.body.BalanceType,
              Text: response.body.Code + " - " + response.body.CodeName,
              TotalBalance: response.body.TotalBalance,
              TotalCredit: response.body.TotalCredit,
              TotalDept: response.body.TotalDept,
            };
            this.items.push(newItem);
            this.searchText = newItem;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            }
          }
        );
    },
    setHesapKodu(element) {
     
      var newItem = {
        CodeID: element.CodeID,
        CompanyID: element.CompanyID,
        Code: element.Code,
        CodeName: element.CodeName,
        BalanceType: element.BalanceType,
        Text: element.Code + " - " + element.CodeName,
        TotalBalance: element.TotalBalance,
        TotalCredit: element.TotalCredit,
        TotalDept: element.TotalDept,
      };
      

      this.selectedID2=element.CodeID;
      this.items.push(newItem);
     

      this.searchText = element.CodeID;
     
      this.searchDialog = false;
      this.$emit('setData',element); 

    },
    getHesapKodu(searchData) {
     
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      
      var params1 = {
        UserID: 0,
        SearchText: escape(searchData),
        CompanyID: credentials.MuhasebeSirketNo,
        MainCodeID: 0,
        Code: 0,
        CodeID: 0,
        BalanceShow: true,
      };

      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeSearch",
          params1,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            //this.items = response.body;
            var newItem;

            response.body.forEach((element) => {
              newItem = {
                CodeID: element.CodeID,
                CompanyID: element.CompanyID,
                Code: element.Code,
                CodeName: element.CodeName,
                BalanceType: element.BalanceType,
                Text: element.Code + " - " + element.CodeName,
                TotalBalance: element.TotalBalance,
                TotalCredit: element.TotalCredit,
                TotalDept: element.TotalDept,
              };

              this.items.push(newItem);
            });
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
            }
          }
        );
    },
    controlChange() {
      this.controlSearch = true;
    },
  },
  watch: {
    searchHesap(val) {
      if (this.controlSearch == false) {
        val && this.getHesapKodu(val);
      } else {
        this.controlSearch = false;
      }
    },
  },
  components: {
    snackbarcomp,
    loadingcomp,
    muhasebeislem,
    hesapkoduara,
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return helpers.getTime(t);
    },
  },
};
</script>

<style scoped>
.rounded-corner {
  border-start-start-radius: 20px;
  border-end-end-radius: 20px;
}
</style>

